<div class="page-root-center">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ "set_password.title" | transloco }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form (ngSubmit)="setPassword()" [formGroup]="setPasswordForm">
        <div class="dialog-root">
          @if (!urlParameter) {
            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.verification_code" | transloco }}</mat-label>
              <input formControlName="verificationCode" matInput type="text">
            </mat-form-field>
          }

          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{ "form.label.password" | transloco }}</mat-label>
            <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput>
            <button (click)="togglePasswordVisibility()" mat-icon-button matSuffix type="button">
              <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{ "form.label.password_repeat" | transloco}}</mat-label>
            <input [type]="hidePasswordRepeat ? 'password' : 'text'" formControlName="passwordRepeat" matInput>
            <button (click)="togglePasswordRepeatVisibility()" mat-icon-button matSuffix type="button">
              <mat-icon>{{ hidePasswordRepeat ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>

          @if (error) {
            <mat-error>{{ error }}</mat-error>
          }

          <button mat-flat-button type="submit">{{ "set_password.button" | transloco }}</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
